module.exports = __webpack_public_path__ + "img/40_69_000_980.9aee29ba.jpg";